export const MAX_GAS_RATE_BEFORE_SEPARATION = 0.8;
export const TURPIN_MAX = 1;
export const VISCOSITY_MAX = 10;
export const MIN_CLEARANCE = 0.1;
export const MIN_PSD = 1000;
export const DLS_INSTALL_LIMIT = 12;
export const DLS_LANDING_LIMIT = 2;
export const INCL_LANDING_LIMIT = 89;
export const SEAL_INCLINATION_LIMIT = 45;
export const PUMP_INTAKE_PRESSURE_LOWER_LIMIT = 10;
export const MAX_PUMP_OUTSIDE_RANGE_RATIO = 0.1;
export const MAX_VOLT_LOST = 30;
export const MIN_STARTUP_VOLTAGE_RATIO = 0.5;
export const MIN_FLOW_VELOCITY = 1;
export const MAX_FLOW_VELOCITY = 12;
export const ABRASIVE_MAX_FV = 7.5;
export const MAX_MOTOR_SKIN_TEMP = 300;
export const MIN_VSD_FREQUECY = 30;
export const MAX_VSD_FREQUECY = 80;
export const POWER_CABLE_BUFFER_LENGTH = 100;
export const LOCK_PLATE_REQUIRED_LENGTH = 2000;
export const SAGD_MLE_FAMILY = "NOSOL KK PFA SAGD MLE";

export const CORRELATIONS_FIELDS = {
  OIL_PVT: [
    "bubble_point",
    "oil_density",
    "oil_volume_factor_saturated",
    "oil_volume_factor_undersaturated",
    "solution_gor" // solution_gas
  ],
  OIL_VISCOSITY: ["dead_oil", "saturated_oil", "under_saturated_oil"],
  WATER_PVT: ["water_volume_factor"],
  WATER_VISCOSITY: ["water_viscosity"],
  GAS_COMPRESSION: ["gas_compressibility"],
  GAS_VISCOSITY: ["gas_viscosity"]
} as const;

export const CORRELATION_LIMITS = {
  OIL_PVT: {
    de_ghetto_heavy_oil: {
      MIN_API: 6,
      MAX_API: 56.8,
      MIN_GAS_SG: 0.624,
      MAX_GAS_SG: 1.789,
      MIN_TEMP: 80.6,
      MAX_TEMP: 341.6,
      MIN_PRESS: 242.22,
      MAX_PRESS: 15304.62,
      MIN_RSO: 8.61,
      MAX_RSO: 3298.66,
      MIN_PB: 107.33,
      MAX_PB: 6613.82,
      MIN_BO: 1.034,
      MAX_BO: 2.887
    },
    glaso_north_sea: {
      MIN_API: 22.3,
      MAX_API: 48.1,
      MIN_GAS_SG: 0.574,
      MAX_GAS_SG: 1.223,
      MIN_TEMP: 1.8,
      MAX_TEMP: 280,
      MIN_RSO: 90,
      MAX_RSO: 2637,
      MIN_PB: 165,
      MAX_PB: 7142,
      MIN_BO: 1.025,
      MAX_BO: 2.588
    },
    kartoatmodjo_schmidt: {
      MIN_API: 14.4,
      MAX_API: 58.95,
      MIN_GAS_SG: 0.65,
      MAX_GAS_SG: 1.276,
      MIN_TEMP: 75,
      MAX_TEMP: 320,
      MIN_PRESS: 10,
      MAX_PRESS: 6000,
      MIN_RSO: 0,
      MAX_RSO: 2890,
      MIN_PB: 0,
      MAX_PB: 6040,
      MIN_BO: 1.022,
      MAX_BO: 2.747
    },
    lasater: {
      MIN_API: 17.9,
      MAX_API: 51.1,
      MIN_GAS_SG: 0.574,
      MAX_GAS_SG: 1.223,
      MIN_TEMP: 82,
      MAX_TEMP: 272,
      MIN_RSO: 3,
      MAX_RSO: 2905,
      MIN_PB: 48,
      MAX_PB: 5780
    },
    petrosky_farshad_gom: {
      MIN_API: 16.3,
      MAX_API: 45,
      MIN_GAS_SG: 0.5781,
      MAX_GAS_SG: 0.8519,
      MIN_TEMP: 114,
      MAX_TEMP: 288,
      MIN_PRESS: 1700,
      MAX_PRESS: 10692,
      MIN_RSO: 217,
      MAX_RSO: 1406,
      MIN_PB: 1574,
      MAX_PB: 6523,
      MIN_BO: 1.1178,
      MAX_BO: 1.6229
    },
    standing: {
      MIN_API: 16.5,
      MAX_API: 63.8,
      MIN_GAS_SG: 0.59,
      MAX_GAS_SG: 0.95,
      MIN_TEMP: 100,
      MAX_TEMP: 258,
      MIN_RSO: 20,
      MAX_RSO: 1425,
      MIN_PB: 130,
      MAX_PB: 7000,
      MIN_BO: 1.024,
      MAX_BO: 2.15
    },
    vasquez_beggs: {
      MIN_API: 15.3,
      MAX_API: 59.5,
      MIN_GAS_SG: 0.511,
      MAX_GAS_SG: 1.351,
      MIN_TEMP: 75,
      MAX_TEMP: 320,
      MIN_PRESS: 141,
      MAX_PRESS: 9515,
      MIN_RSO: 0,
      MAX_RSO: 2199,
      MIN_PB: 15,
      MAX_PB: 6055,
      MIN_BO: 1.028,
      MAX_BO: 2.226
    }
  },
  OIL_VISCOSITY: {
    beggs_robinson: {
      MIN_API: 16,
      MAX_API: 58,
      MIN_TEMP: 70,
      MAX_TEMP: 295,
      MIN_PRESS: 15,
      MAX_PRESS: 5265,
      MIN_RSO: 20,
      MAX_RSO: 2070
    },
    de_ghetto_heavy_oil: {
      MIN_API: 6,
      MAX_API: 56.8,
      MIN_TEMP: 80.6,
      MAX_TEMP: 341.6,
      MIN_PRESS: 242.22,
      MAX_PRESS: 15304.62,
      MIN_RSO: 8.61,
      MAX_RSO: 3298.66,
      MIN_PB: 107.33,
      MAX_PB: 6613.82,
      MIN_U_OD: 0.46,
      MAX_U_OD: 1386.9,
      MIN_U_O: 0.07,
      MAX_U_O: 295.9
    },
    glaso_north_sea: {
      MIN_API: 20.1,
      MAX_API: 48.1,
      MIN_TEMP: 50,
      MAX_TEMP: 300,
      MIN_U_OD: 0.616,
      MAX_U_OD: 39.1
    },
    kartoatmodjo_schmidt: {
      MIN_API: 14.4,
      MAX_API: 58.95,
      MIN_TEMP: 80,
      MAX_TEMP: 320,
      MIN_PRESS: 15,
      MAX_PRESS: 7171,
      MIN_RSO: 1,
      MAX_RSO: 2044,
      MIN_U_OD: 0.5062,
      MAX_U_OD: 682,
      MIN_U_O: 0.096,
      MAX_U_O: 586
    }
  },
  WATER_PVT: {
    gould: {},
    jones: {},
    mccain: {
      MIN_TEMP: 86,
      MAX_TEMP: 260,
      MIN_PRESS: 1000,
      MAX_PRESS: 5000
    },
    spiveyEtAl: {
      MIN_TEMP: 32,
      MAX_TEMP: 572,
      MIN_PRESS: 130,
      MAX_PRESS: 29000
    }
  },
  WATER_VISCOSITY: {
    van_wingen: {
      MIN_TEMP: 40,
      MAX_TEMP: 300,
      MIN_PRESS: 0,
      MAX_PRESS: 7100
    },
    matthews_russel: {},
    mccain: {
      MIN_TEMP: 86,
      MAX_TEMP: 400,
      MIN_PRESS: 0,
      MAX_PRESS: 10000
    }
  },
  GAS_COMPRESSION: {
    beggs_brill: {
      MIN_PPR: 0.92
    },
    cnga: {
      MIN_TEMP: 30.3,
      MAX_TEMP: 140.27,
      MIN_PRESS: 0,
      MAX_PRESS: 1000,
      MIN_GAS_SG: 0.55,
      MAX_GAS_SG: 0.7
    },
    dranchuk_purvis: {
      MIN_PPR: 0.2,
      MAX_PPR: 30,
      MIN_TPR: 1,
      MAX_TPR: 3
    },
    // aka Poettman Carpenter
    standing_katz: {
      MIN_PPR: 0.2,
      MAX_PPR: 30,
      MIN_TPR: 1.05,
      MAX_TPR: 3
    }
  },
  GAS_VISCOSITY: {
    lee: {
      MIN_PPR: 0.4,
      MAX_PPR: 15,
      MIN_TPR: 0.9,
      MAX_TPR: 3.2
    },
    // aka Carr Kobayashi Burrows
    standings_dempsey: {
      MIN_TEMP: 100,
      MAX_TEMP: 340,
      MIN_GAS_SC: 0.55,
      MAX_GAS_SC: 1.55,
      MIN_PPR: 1,
      MAX_PPR: 20,
      MIN_TPR: 1.2,
      MAX_TPR: 3
    },
    // TODO: update this after 1999/2131 merged in
    chen_ruth: {
      MIN_PPR: 1,
      MAX_PPR: 12,
      MIN_TPR: 1.2,
      MAX_TPR: 2.6
    },
    // TODO: update this after 1999/2131 merged in
    dranchuk_purvis: {
      MIN_PPR: 0.11,
      MAX_PPR: 20,
      MIN_TPR: 1.05,
      MAX_TPR: 3
    }
  }
} as const;
